/* eslint-disable jira/naming/disallow-filenames */
// eslint-disable-next-line jira/filename-case
import React, { useEffect, useMemo, useState } from 'react';
import {
	CORE_PROJECT,
	SERVICE_DESK_PROJECT,
	SOFTWARE_PROJECT,
	PRODUCT_DISCOVERY_PROJECT,
	CUSTOMER_SERVICE_PROJECT,
} from '@jira/platform__project-types/src/project-types.tsx';
import AsyncItamSettingsSidebar from '@jira/itam__nav4-settings-sidebar/src/ui/asyncItamSettingsSidebar.tsx';
import { useLocation } from '@jira/navigation-apps__routing-hooks/src/useLocation.tsx';
import { SidebarIdGlobalAppsSettings } from '@jira/navigation-apps__constants/src/SidebarIdGlobalAppsSettings.tsx';
import { SidebarIdGlobalIssuesSettings } from '@jira/navigation-apps__constants/src/SidebarIdGlobalIssuesSettings.tsx';
import { SidebarIdGlobalProductsSettings } from '@jira/navigation-apps__constants/src/SidebarIdGlobalProductsSettings.tsx';
import { SidebarIdGlobalProjectsSettings } from '@jira/navigation-apps__constants/src/SidebarIdGlobalProjectsSettings.tsx';
import { SidebarIdGlobalSystemSettings } from '@jira/navigation-apps__constants/src/SidebarIdGlobalSystemSettings.tsx';
import { SidebarIdHelpCenterSettings } from '@jira/navigation-apps__constants/src/SidebarIdHelpCenterSettings.tsx';
import { SidebarIdItamSettings } from '@jira/navigation-apps__constants/src/SidebarIdItamSettings.tsx';
import { SidebarIdPersonalSettings } from '@jira/navigation-apps__constants/src/SidebarIdPersonalSettings.tsx';
import { SidebarIdPlanSettings } from '@jira/navigation-apps__constants/src/SidebarIdPlanSettings.tsx';
import { SidebarIdProjectSettings } from '@jira/navigation-apps__constants/src/SidebarIdProjectSettings.tsx';
import { SidebarIdSpaceAgents } from '@jira/navigation-apps__constants/src/SidebarIdSpaceAgents.tsx';
import { SidebarIdCsmApp } from '@jira/navigation-apps__constants/src/SidebarIdCsmApp.tsx';
import { SidebarIdOperationsGeneralConfiguration } from '@jira/navigation-apps__constants/src/SidebarIdOperationsGeneralConfiguration.tsx';
import { BOARD_SETTINGS_CONFIG_QUERY_PARAM_VALUES } from '@jira/software__board-settings-rapidboard-config-common/src/boardSettingsQueryConfigParamValues.constants.tsx';
import { useMaybeConfigParam } from '@jira/software__board-settings-rapidboard-config-common/src/useMaybeConfigParam.tsx';
import { useOgTenantInfo } from '@jira/eoc__tenant-info/src/controllers/index.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { V4 } from '@jira/navigation-apps__sidebar-nav4-analytics/src/common/constants/analytics/nav-state.tsx';
import { SIDEBAR } from '@jira/navigation-apps__sidebar-nav4-analytics/src/common/constants/analytics/navigation-container.tsx';
import {
	GLOBAL,
	CONTAINER,
} from '@jira/navigation-apps__sidebar-nav4-analytics/src/common/constants/analytics/navigation-layer.tsx';
import {
	NavigateBackProvider,
	useNavigateBack,
} from '@jira/navigation-apps__sidebar-nav4-sidebars-common-back-button/src/controllers/navigate-back-context/index.tsx';
import { SidebarContent } from '@jira/navigation-apps__sidebar-nav4-sidebars-content-core/src/index.tsx';
import { SideNavBody } from '@atlaskit/navigation-system/layout/side-nav';
import { FormattedMessage, defineMessage } from '@atlassian/jira-intl';
import AsyncBoardSettingsSidebar from '@jira/navigation-apps__sidebar-nav4-sidebars-settings-board/src/ui/index.tsx';
import { Skeleton as BoardSettingsSkeleton } from '@jira/navigation-apps__sidebar-nav4-sidebars-settings-board/src/ui/skeleton/index.tsx';
import { useGlobalAppsSettingsConnectItemActive } from '@jira/navigation-apps__sidebar-nav4-sidebars-settings-global-apps/src/controllers/global-settings/index.tsx';
import AsyncGlobalAppsSettingsSidebar from '@jira/navigation-apps__sidebar-nav4-sidebars-settings-global-apps/src/ui/index.tsx';
import AsyncGlobalIssuesSettingsSidebar from '@jira/navigation-apps__sidebar-nav4-sidebars-settings-global-issues/src/ui/index.tsx';
import { SidebarContentWithRelayResource } from '@jira/navigation-apps__sidebar-nav4-sidebars-settings-global-products/src/ui/index.tsx';
import AsyncGlobalProjectsSettingsSidebar from '@jira/navigation-apps__sidebar-nav4-sidebars-settings-global-projects/src/ui/index.tsx';
import AsyncOperationsGeneralConfigrationSidebar from '@jira/navigation-apps__sidebar-nav4-sidebars-settings-global-operations/src/ui/index.tsx';
import { useGlobalSystemSettingsConnectItemActive } from '@jira/navigation-apps__sidebar-nav4-sidebars-settings-global-system/src/controllers/global-settings/index.tsx';
import AsyncGlobalSystemSettingsSidebar from '@jira/navigation-apps__sidebar-nav4-sidebars-settings-global-system/src/ui/index.tsx';
import AsyncCsmAppSidebar from '@jira/navigation-apps__sidebar-nav4-sidebars-content-csm-app/src/AsyncCsmAppSidebar.tsx';
import AsyncHelpCenterSettingsSidebar from '@jira/navigation-apps__sidebar-nav4-sidebars-settings-help-center/src/ui/index.tsx';
import AsyncPersonalSettingsSidebar from '@jira/navigation-apps__sidebar-nav4-sidebars-settings-personal/src/ui/index.tsx';
import AsyncPlanSettingsSidebar from '@jira/navigation-apps__sidebar-nav4-sidebars-settings-plan/src/ui/index.tsx';
import AsyncBusinessCompanyManagedProjectSettingsSidebar from '@jira/navigation-apps__sidebar-nav4-sidebars-settings-project-business-company-managed/src/ui/index.tsx';
import AsyncBusinessTeamManagedProjectSettingsSidebar from '@jira/navigation-apps__sidebar-nav4-sidebars-settings-project-business-team-managed/src/ui/index.tsx';
import { Skeleton as ProjectSettingsSkeleton } from '@jira/navigation-apps__sidebar-nav4-sidebars-settings-project-common/src/common/ui/skeleton/index.tsx';
import { useIsConnectAppActive as useIsProjectSettingsConnectAppActive } from '@jira/navigation-apps__sidebar-nav4-sidebars-settings-project-common/src/controllers/is-connect-app-active/index.tsx';
import { AsyncProjectSettingsSidebar as AsyncJpdProjectSettingsSidebar } from '@jira/navigation-apps__sidebar-nav4-sidebars-settings-project-product-discovery/src/ui/AsyncProjectSettingsSidebar.tsx';
import { AsyncJsmCmpProjectSettingsSidebar } from '@jira/navigation-apps__sidebar-nav4-sidebars-settings-project-service-desk-company-managed/src/index.tsx';
import { AsyncJsmTmpProjectSettingsSidebar } from '@jira/navigation-apps__sidebar-nav4-sidebars-settings-project-service-desk-team-managed/src/index.tsx';
import { AsyncJcsProjectSettingsSidebar } from '@jira/navigation-apps__sidebar-nav4-sidebars-settings-project-customer-service/src/index.tsx';
import AsyncSoftwareCompanyManagedProjectSettingsSidebar from '@jira/navigation-apps__sidebar-nav4-sidebars-settings-project-software-company-managed/src/ui/index.tsx';
import AsyncSoftwareTeamManagedProjectSettingsSidebar from '@jira/navigation-apps__sidebar-nav4-sidebars-settings-project-software-team-managed/src/ui/index.tsx';
import { ContextualAnalyticsData } from '@atlassian/jira-product-analytics-bridge';
// eslint-disable-next-line jira/restricted/@jira+platform__services-providers-project-context
import { useProjectContext } from '@jira/platform__services-providers-project-context/src/index.tsx';
import { getRouterState } from '@atlassian/react-resource-router';
import {
	addRouteListener,
	createRouterSelector,
} from '@atlassian/react-resource-router/src/controllers/router-store';
import type { RouterState } from '@atlassian/react-resource-router/src/controllers/router-store/types';
import type { RouteName } from '@jira/platform__routing-route-name-types/src/RouteName.tsx';

const entitySettingsSidebarAnalyticsAttributes = {
	navigationLayer: CONTAINER,
};

const ProjectSettingsSidebarSelector = () => {
	const { data: project, loading, error } = useProjectContext();

	let sidebar = null;
	if (loading) {
		sidebar = <ProjectSettingsSkeleton />;
	}
	if (error) {
		throw error;
	}

	if (project?.projectType === CORE_PROJECT) {
		sidebar = project.simplified ? (
			<AsyncBusinessTeamManagedProjectSettingsSidebar project={project} />
		) : (
			<AsyncBusinessCompanyManagedProjectSettingsSidebar project={project} />
		);
	}

	if (project?.projectType === SOFTWARE_PROJECT) {
		sidebar = project.simplified ? (
			<AsyncSoftwareTeamManagedProjectSettingsSidebar project={project} />
		) : (
			<AsyncSoftwareCompanyManagedProjectSettingsSidebar project={project} />
		);
	}

	if (project?.projectType === PRODUCT_DISCOVERY_PROJECT) {
		sidebar = <AsyncJpdProjectSettingsSidebar project={project} />;
	}

	if (project?.projectType === CUSTOMER_SERVICE_PROJECT) {
		sidebar = <AsyncJcsProjectSettingsSidebar project={project} />;
	}

	if (project?.projectType === SERVICE_DESK_PROJECT) {
		sidebar = project.simplified ? (
			<AsyncJsmTmpProjectSettingsSidebar project={project} />
		) : (
			<AsyncJsmCmpProjectSettingsSidebar project={project} />
		);
	}

	if (!sidebar) {
		throw new Error(
			`No project settings sidebar found for the project type: ${project?.projectType}`,
		);
	}

	return (
		<ContextualAnalyticsData
			containerId={project ? String(project.projectId) : undefined}
			containerType="project"
			attributes={entitySettingsSidebarAnalyticsAttributes}
		>
			{sidebar}
		</ContextualAnalyticsData>
	);
};

const ConnectAppSidebarSelector = () => {
	const { isActive: isProjectSettingsConnectAppActive } = useIsProjectSettingsConnectAppActive();

	return isProjectSettingsConnectAppActive ? <ProjectSettingsSidebarSelector /> : null;
};

const BoardSettingsSidebar = () => {
	const { data: project, loading, error } = useProjectContext();

	if (loading) {
		return <BoardSettingsSkeleton />;
	}

	if (error) {
		throw error;
	}

	return (
		<ContextualAnalyticsData
			containerId={project ? String(project.projectId) : undefined}
			containerType="project"
			attributes={entitySettingsSidebarAnalyticsAttributes}
		>
			<AsyncBoardSettingsSidebar />
		</ContextualAnalyticsData>
	);
};
// Minimal, content-only sidebar for the Agents Home space settings page (PR1).
// Resize/collapse/width-persistence are provided by the shared shell (SidebarEntry /
// @atlaskit/navigation-system). Real menu content is added in a later PR.
const spaceAgentsSidebarPlaceholderMessage = defineMessage({
	id: 'navigation-apps.sidebar-nav4-sidebar-selector.space-agents-sidebar.placeholder',
	defaultMessage: 'hello world sidebar',
	description: 'Placeholder text shown in the Agents Home space settings sidebar.',
});

const SpaceAgentsSidebar = () => (
	<ContextualAnalyticsData attributes={entitySettingsSidebarAnalyticsAttributes}>
		<SideNavBody>
			<FormattedMessage {...spaceAgentsSidebarPlaceholderMessage} />
		</SideNavBody>
	</ContextualAnalyticsData>
);

const REDIRECT_ROUTES_NAMES = new Set<RouteName>([
	'browse-project-redirect',
	'servicedesk-redirect',
]);

const getSidebarForRoute = (
	state: RouterState,
	{
		configParam,
		shouldUseJSM,
		isGlobalAppsSettingsConnectItemActive,
		isGlobalSystemSettingsConnectItemActive,
		isProjectSettingsConnectAppActive,
	}: {
		configParam: string;
		shouldUseJSM: boolean;
		isGlobalAppsSettingsConnectItemActive: boolean;
		isGlobalSystemSettingsConnectItemActive: boolean;
		isProjectSettingsConnectAppActive: boolean;
	},
) => {
	const sidebarId = state.route.navigation?.sidebarId;
	const pathname = state.location.pathname;

	/**
	 * HEAR YE! HEAR YE!
	 *
	 * When making changes to this file, you MUST make corresponding changes to
	 * src/packages/navigation-apps/sidebar-nav4-sidebar-selector/src/common/logic.tsx
	 *
	 * The logic.tsx is used in two circumstances:
	 *  - for entrypoint routes in Nav4
	 *  - for the new global side navigation (GSN) component, which will (somewhat) replace sidebar-nav4
	 *
	 * In 2024, while building Nav4, we tried to replace this file entirely with the logic.tsx file.
	 * However, there were some differences in the logic, and the change was rolled back. We never
	 * got around to deprecating this file in favour of logic.tsx.
	 *
	 * GSN will force the deprecation of this file by exclusively using logic.tsx.
	 */

	const isChatOpsPath = pathname.includes('/jira-service-management-chatops-and-video-tools');
	const hasChatOpsTenantAccess = shouldUseJSM;

	switch (sidebarId) {
		case SidebarIdCsmApp:
			if (fg('csm_appification_standalone_navigation')) {
				return <AsyncCsmAppSidebar />;
			}
			break;
		case SidebarIdPlanSettings:
			return <AsyncPlanSettingsSidebar />;
		case SidebarIdGlobalAppsSettings:
			if (!pathname.includes('/discover')) {
				return <AsyncGlobalAppsSettingsSidebar />;
			}
			break;
		case SidebarIdGlobalProjectsSettings:
			return <AsyncGlobalProjectsSettingsSidebar />;
		case SidebarIdGlobalIssuesSettings:
			return <AsyncGlobalIssuesSettingsSidebar />;
		case SidebarIdGlobalProductsSettings:
			if (isChatOpsPath && hasChatOpsTenantAccess) {
				break;
			}
			return <SidebarContentWithRelayResource />;
		case SidebarIdGlobalSystemSettings:
			return <AsyncGlobalSystemSettingsSidebar />;
		case SidebarIdPersonalSettings:
			return <AsyncPersonalSettingsSidebar />;
		case SidebarIdHelpCenterSettings:
			return <AsyncHelpCenterSettingsSidebar />;
		case SidebarIdItamSettings:
			return <AsyncItamSettingsSidebar />;
		case SidebarIdProjectSettings:
			return <ProjectSettingsSidebarSelector />;
		case SidebarIdSpaceAgents:
			return <SpaceAgentsSidebar />;
		case SidebarIdOperationsGeneralConfiguration:
			return <AsyncOperationsGeneralConfigrationSidebar />;
		default:
			break;
	}

	if (state.route.name === 'polaris-ideas' && state.match.params.section === 'settings') {
		return <ProjectSettingsSidebarSelector />;
	}

	if (state.route.name === 'your-work') {
		return <SidebarContent />;
	}

	if (isProjectSettingsConnectAppActive) {
		return <ConnectAppSidebarSelector />;
	}

	if (
		state.route.group === 'classic-software' &&
		BOARD_SETTINGS_CONFIG_QUERY_PARAM_VALUES.has(configParam)
	) {
		return <BoardSettingsSidebar />;
	}

	if (isGlobalAppsSettingsConnectItemActive) {
		return <AsyncGlobalAppsSettingsSidebar />;
	}
	if (isGlobalSystemSettingsConnectItemActive) {
		return <AsyncGlobalSystemSettingsSidebar />;
	}
};

export const isNonRedirectRouteTest = (state: RouterState): boolean => {
	return !REDIRECT_ROUTES_NAMES.has(state.route.name);
};

// oxlint-disable-next-line typescript/no-invalid-void-type
export const useIsNonRedirectRoute: (args_0: void) => boolean =
	createRouterSelector(isNonRedirectRouteTest);

export const InternalSidebarSelector = ():
	| string
	| number
	| true
	| Iterable<React.ReactNode>
	| React.JSX.Element => {
	const { saveCurrentRoute } = useNavigateBack();
	const { isActive: isGlobalAppsSettingsConnectItemActive } =
		useGlobalAppsSettingsConnectItemActive();
	const { isActive: isGlobalSystemSettingsConnectItemActive } =
		useGlobalSystemSettingsConnectItemActive();
	const { isActive: isProjectSettingsConnectAppActive } = useIsProjectSettingsConnectAppActive();
	const { shouldUseJSM } = useOgTenantInfo();
	const isNonRedirectRoute = useIsNonRedirectRoute();
	const configParam = useMaybeConfigParam() || '';
	const location = useLocation();
	const [sidebar, setSidebar] = useState<React.ReactNode | null>(
		getSidebarForRoute(getRouterState(), {
			configParam,
			shouldUseJSM,
			isGlobalAppsSettingsConnectItemActive,
			isGlobalSystemSettingsConnectItemActive,
			isProjectSettingsConnectAppActive,
		}),
	);

	useEffect(() => {
		return addRouteListener((state) => {
			setSidebar(
				getSidebarForRoute(state, {
					configParam: state.query.config || state.match.params.config || '',
					isGlobalAppsSettingsConnectItemActive,
					isGlobalSystemSettingsConnectItemActive,
					isProjectSettingsConnectAppActive,
					shouldUseJSM,
				}),
			);
		});
	}, [
		isGlobalAppsSettingsConnectItemActive,
		isGlobalSystemSettingsConnectItemActive,
		isProjectSettingsConnectAppActive,
		shouldUseJSM,
	]);

	useEffect(() => {
		// NOTE: We need to AVOID saving the route if we're on a connect app...
		if (!sidebar && isNonRedirectRoute && !isProjectSettingsConnectAppActive) {
			const url = `${location.pathname}${location.search}${location.hash}`;
			saveCurrentRoute(url);
		}

		if (!sidebar && isProjectSettingsConnectAppActive) {
			setSidebar(<ConnectAppSidebarSelector />);
		}
	}, [isNonRedirectRoute, isProjectSettingsConnectAppActive, location, saveCurrentRoute, sidebar]);

	if (sidebar) {
		return sidebar;
	}

	// Main nav (with "Your work", Starred, Recent items etc.)
	return <SidebarContent />;
};

export const SidebarSelector = (): React.JSX.Element => {
	const attributes = useMemo(
		() => ({
			navigationLayer: GLOBAL,
			navigationContainer: SIDEBAR,
			navState: V4,
		}),
		[],
	);

	return (
		<NavigateBackProvider>
			<ContextualAnalyticsData attributes={attributes}>
				<InternalSidebarSelector />
			</ContextualAnalyticsData>
		</NavigateBackProvider>
	);
};
